/**
 * Contabile (fork): stato di sessione dell'ingresso dimostrativo.
 *
 * La landing statica su `/` porta a `/app.html?demo=1`. Con quel parametro
 * l'app apre da sola il budget di esempio (o lo crea, riusando il flusso
 * upstream `createBudget({ testMode: true })`) e mostra il dialogo
 * "Ambiente dimostrativo". Lo stesso dialogo compare quando la demo parte
 * dal pulsante interno della schermata di benvenuto.
 *
 * Tutto lo stato vive in `sessionStorage`: a ogni nuova sessione del browser
 * il dialogo ricompare e la chip "Demo" torna visibile. Nessun dato lascia
 * il browser.
 */

/** Nome del file dimostrativo, come lo scrive `createTestBudget` del fork. */
export const NOME_BUDGET_DEMO = 'Budget dimostrativo';

const CHIAVE_BENVENUTO = 'contabile-demo-benvenuto';
const CHIAVE_CHIP = 'contabile-demo-chip';

/** Chiave con cui `tour.js` ricorda che la visita guidata è stata vista. */
const CHIAVE_TOUR_VISTO = 'gdp-tour-visto:contabile';

/** `true` se l'URL corrente è un ingresso demo dalla landing (`?demo=1`). */
export function entrataDemoRichiesta(): boolean {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).get('demo') === '1';
}

/** Segna che al prossimo ingresso nel budget va mostrato il benvenuto demo. */
export function segnaBenvenutoDemoInAttesa(): void {
  try {
    sessionStorage.setItem(CHIAVE_BENVENUTO, 'attesa');
  } catch {
    // navigazione privata: il dialogo semplicemente non comparirà
  }
}

export function benvenutoDemoInAttesa(): boolean {
  try {
    return sessionStorage.getItem(CHIAVE_BENVENUTO) === 'attesa';
  } catch {
    return false;
  }
}

export function consumaBenvenutoDemo(): void {
  try {
    sessionStorage.removeItem(CHIAVE_BENVENUTO);
  } catch {
    // niente da fare
  }
}

/**
 * Chi sceglie "Esplora liberamente" ha già rifiutato la visita guidata nel
 * dialogo: non va riproposta in automatico. Stessa chiave e stesso valore
 * che scriverebbe `tour.js` su "Salta".
 */
export function segnaTourComeVisto(): void {
  try {
    localStorage.setItem(CHIAVE_TOUR_VISTO, 'saltato');
  } catch {
    // niente da fare
  }
}

export function chipDemoChiusa(): boolean {
  try {
    return sessionStorage.getItem(CHIAVE_CHIP) === 'chiusa';
  } catch {
    return false;
  }
}

export function chiudiChipDemo(): void {
  try {
    sessionStorage.setItem(CHIAVE_CHIP, 'chiusa');
  } catch {
    // niente da fare
  }
}
